import { render, staticRenderFns } from "./featureBox.vue?vue&type=template&id=c9b0bd76&scoped=true&"
import script from "./featureBox.vue?vue&type=script&lang=js&"
export * from "./featureBox.vue?vue&type=script&lang=js&"
import style0 from "./featureBox.vue?vue&type=style&index=0&id=c9b0bd76&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b0bd76",
  null
  
)

export default component.exports